import React, {useEffect, useState} from "react"

import soundDown from "@shared/assets/images/s-no.png"
import soundUp from "@shared/assets/images/s-uo.png"
import videoError from "@shared/assets/images/v-abnor.png"
import videoNormal from "@shared/assets/images/v-nor.png"
import {useAccount, useHandleMessagesContext, useLayerPopupContext} from "../../contexts";
import {Message} from "../../hooks/useMessages";
import {useSnackbar} from "notistack";

export const broadcastCheckButtonTypes = {
  videoNormal: "화면 정상",
  videoError: "화면 안보임",
  soundUp: "볼륨 업",
  soundDown: "소리 안들림",
}

type CheckButtonTypes = typeof broadcastCheckButtonTypes

export const CheckText = '[방송체크]'

const CheckButton = () => {
  const { send } = useHandleMessagesContext()
  const { enqueueSnackbar } = useSnackbar();
  const { open, stock, alert } = useLayerPopupContext()
  const { account } = useAccount()

  const [openCheckButton, setOpenCheckButton] = useState<boolean>(false)
  const [videoNormalThrottle, setVideoNormalThrottle] = useState<boolean>(false)
  const [videoErrorThrottle, setVideoErrorThrottle] = useState<boolean>(false)
  const [soundUpThrottle, setSoundUpThrottle] = useState<boolean>(false)
  const [soundDownThrottle, setSoundDownThrottle] = useState<boolean>(false)

  const handleClickToggleCheckButton = () => {
    if (account.viewer?.role === "ANONYMOUS") {
      open("ANONYMOUS")
      return
    }
    
    setOpenCheckButton(!openCheckButton)
  }

  const handleVideoNormalButtonClick = (
    e: React.MouseEvent<HTMLDivElement>,
    option: string,
  ) => {
    const button = e.currentTarget
    if (videoNormalThrottle) {
      showAlert(option)
      return
    }

    setVideoNormalThrottle(true)
    button.classList.add("on")
    setTimeout(() => {
      button.classList.remove("on")
      setVideoNormalThrottle(false)
    }, 60000)

    sendMessage(option)
  }

  const handleVideoErrorButtonClick = (
    e: React.MouseEvent<HTMLDivElement>,
    option: string,
  ) => {
    const button = e.currentTarget
    if (videoErrorThrottle) {
      showAlert(option)
      return
    }

    setVideoErrorThrottle(true)
    button.classList.add("on")
    setTimeout(() => {
      button.classList.remove("on")
      setVideoErrorThrottle(false)
    }, 60000)

    sendMessage(option)
  }

  const handleSoundUpButtonClick = (
    e: React.MouseEvent<HTMLDivElement>,
    option: string,
  ) => {
    const button = e.currentTarget
    if (soundUpThrottle) {
      showAlert(option)
      return
    }

    setSoundUpThrottle(true)
    button.classList.add("on")
    setTimeout(() => {
      button.classList.remove("on")
      setSoundUpThrottle(false)
    }, 60000)

    sendMessage(option)
  }

  const handleSoundDownButtonClick = (
    e: React.MouseEvent<HTMLDivElement>,
    option: string,
  ) => {
    const button = e.currentTarget
    if (soundDownThrottle) {
      showAlert(option)
      return
    }

    setSoundDownThrottle(true)
    button.classList.add("on")
    setTimeout(() => {
      button.classList.remove("on")
      setSoundDownThrottle(false)
    }, 60000)

    sendMessage(option)
  }

  const showAlert = (option: string) => {
    alert.handleAlert({ contents: `이미 ${option} 상태를 보내셨습니다.\n1분 후에 다시 이용 가능합니다.` })
    open("ALERT")
  }

  const sendMessage = (option: string) => {
    const message = `${CheckText}${option}`
    send({
      body: message,
      emoji: message // emoji로 사용할시 주석 해제
    } as Message)
    const snackbarMessage = option === broadcastCheckButtonTypes.videoNormal ? `[${option}] 버튼을 눌렀습니다.` : `[${option}] 버튼을 눌렀습니다.\n방송상태가 계속 좋지 않으면 1566-9367로 문의하여 주시기 바랍니다.`
    enqueueSnackbar(snackbarMessage, { variant: "success",  anchorOrigin: { vertical: "top", horizontal: "right" }, style: { whiteSpace: 'pre-line' } });
  }

  return (
    <div className="checkButtonWrapper">
      <div className="checkButton" onClick={handleClickToggleCheckButton}>
        방송체크
      </div>
      {openCheckButton && (
        <div className="checkButtonListWrapper">
          <div className="videoButton">
            <div
              className="circleButton"
              onClick={(e) => handleVideoNormalButtonClick(e, broadcastCheckButtonTypes.videoNormal)}
            />
            <div>
              <img src={videoNormal} />
            </div>
            <div className="checkText">화면 정상</div>
          </div>
          <div className="videoButton">
            <div
              className="circleButton"
              onClick={(e) => handleVideoErrorButtonClick(e, broadcastCheckButtonTypes.videoError)}
            />
            <div>
              <img src={videoError} />
            </div>
            <div className="checkText">화면 안보임</div>
          </div>
          <div className="videoButton">
            <div
              className="circleButton"
              onClick={(e) => handleSoundUpButtonClick(e, broadcastCheckButtonTypes.soundUp)}
            />
            <div>
              <img src={soundUp}/>
            </div>
            <div className="checkText">불륩 업</div>
          </div>
          <div className="videoButton">
            <div
              className="circleButton"
              onClick={(e) => handleSoundDownButtonClick(e, broadcastCheckButtonTypes.soundDown)}
            />
            <div>
              <img src={soundDown}/>
            </div>
            <div className="checkText">소리 안들림</div>
          </div>
        </div>
      )}
    </div>
  )
}

export default CheckButton
